import mapper from '../mapper/index.js';
import { getStorage } from '../../utilities/nojq/_localstorage.js';

const isSSR = typeof window === 'undefined';

function getGeo(geo, glb) {
    var geostorage = getStorage('mapsearch.geo');
    if (geostorage && geostorage.cityId) {
        return mapper.geo(geostorage);
    }
    return geo;
}

function updateHome(state, { data, glb }) {
    state.popularCityList = data.popularCityList;
    state.stateList = data.stateList;
    state.statePathPrefix = data.statePathPrefix;
    state.showViewAllStates = data.showViewAllStates;
    state.stateLinkTextKey = data.stateLinkTextKey;
}
export default {
    updateHome,
};
